import checkoutAddressFilter from "./address-filter";

window.addEventListener('load', () => {
    checkoutAddressFilter.initCheckoutAddressPagination();
    checkoutAddressFilter.doneTyping('address-filter-search', function (element) {
        checkoutAddressFilter.search(element);
    });
}, false);

const addressSearchElements = document.querySelectorAll('.address-filter-search');
if (addressSearchElements.length > 0) {
    _.each(addressSearchElements, function (input) {
        input.addEventListener('keydown', function (e) {
            if (e.keyCode === 13) {
                e.preventDefault();
                checkoutAddressFilter.search(this);
            }
        });
    });
}

$(document).on('click', '.is-choose-element', function (event) {
    const content = $(this).closest('.is-card-summary').find('.is-address-content').html(), wrapper = $(this).closest('.is-swiper-select-container');
    wrapper.find('.is-card-summary.border-success').find('.is-address-content .content').html(content);
    wrapper.find('.is-choose-element').prop('disabled', false);
    $(this).prop('disabled', true);
    //Set address id into input field
    wrapper.find('.address-id').val($(this).attr('data-id'));
});
